module.exports = __webpack_public_path__ + "2024611:ed75de4ab11883afa87d/img/tmm-web-desk.360e8e2.webp";